<template>
  <div class="col-12">
    <div class="forms">
      <div class="row">
        <div class="col-12">
          <label><input type="text" class="text-input" ref="cityInput" v-model="city"/>Miejscowość</label>
        </div>
        <div class="col-12">
          <label>
            <input
              v-model="street"
              type="text"
              class="text-input"
              aria-label="Nazwa ulicy"
            />
            Nazwa ulicy</label>
        </div>

        <div class="col-12">
          <label>
            <input
              v-model="postalCode"
              style="height: 2rem; font-size: .8rem; width: 10rem"
              class="text-input"
            />
            Kod pocztowy
          </label>
        </div>

        <div class="col-12">
          <label>
            <input
              v-model="number"
              type="text"
              class="text-input building-input"
              aria-label="Numer budynku"
              style="width: 5rem"
            />
            Numer budynku
          </label>

        </div>

        <div class="col-12">
          <label>
            <input
              v-model="localNumber"
              type="text"
              class="text-input building-input"
              aria-label="Numer lokalu"
              style="width: 5rem"
            />
            Numer lokalu
          </label>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/components/declarations/validators/Common";
import ForeignAddressValidation from "@/components/declarations/validators/ForeignAddressValidation";

export default {
  name: "ForeignAddress",
  mixins: [Common, ForeignAddressValidation],
  data() {
    return {
      voivodeship: "",
      county: "",
      community: "",
      city: "",
      street: "",
      number: "",
      localNumber: "",
      postalCode: "",
    }
  },
  methods: {
    setData(data) {
      this.city = data.city_D10;
      this.community = data.community_D09;
      this.county = data.county_D08;
      this.number = data.number_D12;
      this.postalCode = data.postal_code_D14;
      this.localNumber = data.premises_number_D13;
      this.street = data.street_D11;
      this.voivodeship = data.voivodeship_D07;
    },
    getAddress() {
      return {
        voivodeship_D07: this.voivodeship,
        county_D08: this.county,
        community_D09: this.community,
        city_D10: this.city,
        street_D11: this.street,
        number_D12: this.number,
        premises_number_D13: this.localNumber,
        postal_code_D14: this.postalCode,
      };
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

.zone-modal .forms {
  padding: .5rem 0.3rem 0 .1rem;
}

.text-input {
  margin-bottom: .3rem;
}

input[type=text] {
  height: 2rem;
  font-size: .8rem;
  width: 25rem;
  margin-right: 1rem;
}
</style>
